<template>
  <div>
    <el-dialog 
      :title="title" 
      :visible="visible" 
      width="800px" 
      @close="onClose"
      :close-on-click-modal="false"
      class="alipay-dialog"
    >
      <div class="dialog-content">
        <!-- 搜索栏 -->
        <div class="search-section">
          <div class="search-row">
            <el-input 
              v-model="keyword" 
              placeholder="请输入快递公司名称"
              prefix-icon="el-icon-search"
              clearable
              size="small"
              class="search-input"
              @keyup.enter.native="chooseItem"
            ></el-input>
            <el-button type="primary" @click="chooseItem" size="small">查询</el-button>
            <el-button @click="resetSearch" size="small">重置</el-button>
          </div>
        </div>

        <!-- 快速新增区域 -->
        <div class="quick-add-section">
          <div class="quick-add-row">
            <el-input 
              v-model="addForm.name" 
              placeholder="请输入快递公司名称"
              prefix-icon="el-icon-plus"
              clearable
              size="small"
              class="add-input"
            ></el-input>
            <el-button type="success" @click="save" size="small">快速新增</el-button>
          </div>
          <div class="quick-tip">
            <i class="el-icon-info"></i>
            <span>如果快递公司不存在，可直接添加入库</span>
          </div>
        </div>

        <!-- 表格 -->
        <div class="table-wrapper">
          <el-table
            ref="multipleTable"
            :data="mList"
            stripe
            border
            size="medium"
            :header-cell-style="headerCellStyle"
            @row-click="handleRowClick"
            v-loading="loading"
            element-loading-text="加载中..."
            height="350"
          >
            <el-table-column label="选择" width="60" align="center">
              <template slot-scope="scope">
                <el-radio 
                  v-model="curShop" 
                  :label="scope.row" 
                  @input="clickChange(scope.row, scope.$index)"
                >{{ "" }}</el-radio>
              </template>
            </el-table-column>
            
            <el-table-column
              label="快递编码"
              width="120"
              prop="shipping_code"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span class="code-text">{{ scope.row.shipping_code || '-' }}</span>
              </template>
            </el-table-column>
            
            <el-table-column
              label="快递名称"
              min-width="180"
              prop="shipping_name"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="name-cell">
                  <i class="el-icon-truck"></i>
                  <span>{{ scope.row.shipping_name }}</span>
                </div>
              </template>
            </el-table-column>
            
            <el-table-column
              label="联系电话"
              width="150"
              prop="mobile"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <div class="mobile-cell">
                  <i class="el-icon-phone"></i>
                  <span>{{ scope.row.mobile || '-' }}</span>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 空状态 -->
        <div v-if="mList.length === 0 && !loading" class="empty-state">
          <i class="el-icon-truck"></i>
          <p>暂无快递公司数据</p>
          <el-button type="primary" size="small" @click="addForm.name = ''; $nextTick(() => $el.querySelector('.add-input input').focus())">
            立即添加
          </el-button>
        </div>

        <!-- 分页 -->
        <div class="pagination-wrapper" v-if="total > 0">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 30, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            :pager-count="5"
          ></el-pagination>
        </div>

        <!-- 底部按钮 -->
        <div class="dialog-footer">
          <el-button size="medium" @click="close" icon="el-icon-close">取消</el-button>
          <el-button size="medium" type="primary" @click="ok" icon="el-icon-check">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'eShoppingList',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    formData: {
      type: Object,
      default: () => ({}),
    },
    title: {
      type: String,
      default: "选择快递公司",
    },
    closeForm: {
      type: Function,
      default: () => {}
    },
  },
  data() {
    return {
      loading: false,
      index: '',
      curShop: null,
      id: '',
      name: '',
      keyword: '',
      mList: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      item: {},
      addForm: {
        name: '',
      }
    }
  },
  mounted() {
    this.DataList()
  },
  methods: {
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    
    // 重置搜索
    resetSearch() {
      this.keyword = ''
      this.pageNum = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    // 点击行选中
    handleRowClick(row, index) {
      this.curShop = row
      this.index = index
      this.id = row.shipping_id
      this.name = row.shipping_name
      // this.formData.name = row.shipping_name
      // this.formData.id = row.shipping_id
      this.item = row
    },
    
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.pageNum = 1
      this.DataList()
    },
    
    handleCurrentChange(newPage) {
      this.pageNum = newPage
      this.DataList()
    },
    
    onClose() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    close() {
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    ok() {
      if (!this.id) {
        this.$message.warning('请选择一家快递公司')
        return
      }
      this.$emit('eventChoose', this.id, this.name, this.item)
      this.$emit('update:visible', false)
      if (this.closeForm) {
        this.closeForm()
      }
    },
    
    // 快速新增快递公司
    save() {
      if (!this.addForm.name || this.addForm.name.trim() === '') {
        this.$message.warning('请输入快递公司名称')
        return
      }
      
      const params = {
        name: this.addForm.name.trim(),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
      }
      
      this.$axios.shippingSave(params).then(res => {
        if (res.code == 200) {
          this.$message.success('添加成功')
          this.addForm.name = ''
          this.pageNum = 1
          this.DataList()
        } else {
          this.$message.error(res.msg || '添加失败')
        }
      }).catch(error => {
        console.log(error)
        this.$message.error('添加失败，请重试')
      })
    },
    
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        page: this.pageNum,
        pageSize: this.pageSize,
      }
      
      if (this.keyword && this.keyword.trim() !== '') {
        param.keyword = this.keyword.trim()
      }
      
      this.$axios.shippingListP(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.mList = res.data.data || []
          this.total = res.data.total || 0
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    clickChange(row, index) {
      this.index = index
      this.id = row.shipping_id
      this.name = row.shipping_name
      // this.formData.name = row.shipping_name
      // this.formData.id = row.shipping_id
      this.item = row
    },
    
    chooseItem() {
      this.pageNum = 1
      this.DataList()
    }
  },
  watch: {
    visible(val) {
      if (val) {
        this.pageNum = 1
        this.keyword = ''
        this.addForm.name = ''
        this.DataList()
        this.curShop = null
        this.id = ''
        this.name = ''
      }
    },
  },
}
</script>

<style lang="scss" scoped>
// 弹框样式
.alipay-dialog {
  ::v-deep .el-dialog {
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
    
    .el-dialog__header {
      background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%);
      padding: 16px 20px;
      margin: 0;
      
      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 500;
      }
      
      .el-dialog__headerbtn .el-dialog__close {
        color: #fff;
        font-size: 18px;
        
        &:hover {
          color: rgba(255, 255, 255, 0.8);
        }
      }
    }
    
    .el-dialog__body {
      padding: 0;
    }
  }
}

.dialog-content {
  padding: 20px 24px 24px;
}

// 搜索区域
.search-section {
  margin-bottom: 16px;
  
  .search-row {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  
  .search-input {
    flex: 1;
    max-width: 260px;
    
    ::v-deep .el-input__inner {
      border-radius: 20px;
    }
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    border-radius: 20px;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
}

// 快速新增区域
.quick-add-section {
  background: #f8f9fc;
  border-radius: 12px;
  padding: 16px 20px;
  margin-bottom: 20px;
  border: 1px solid #e4e7ed;
  
  .quick-add-row {
    display: flex;
    gap: 12px;
    align-items: center;
    margin-bottom: 10px;
  }
  
  .add-input {
    flex: 1;
    max-width: 260px;
    
    ::v-deep .el-input__inner {
      border-radius: 20px;
    }
  }
  
  .el-button--success {
    background: #00b578;
    border-color: #00b578;
    border-radius: 20px;
    
    &:hover {
      background: #1acd8c;
      border-color: #1acd8c;
    }
  }
  
  .quick-tip {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #8c8f98;
    
    i {
      color: #1677ff;
    }
  }
}

// 表格样式
.table-wrapper {
  margin-bottom: 16px;
  border-radius: 12px;
  overflow: hidden;
  
  ::v-deep .el-table {
    border-radius: 12px;
    overflow: hidden;
    
    &::before {
      display: none;
    }
    
    th {
      background: #fafbfc !important;
      font-weight: 500;
    }
    
    td {
      border-bottom: 1px solid #f0f0f0;
    }
    
    .el-table__row {
      transition: background 0.2s;
      cursor: pointer;
      
      &:hover {
        background: #f8f9fc;
      }
    }
    
    .el-radio__input.is-checked .el-radio__inner {
      background-color: #1677ff;
      border-color: #1677ff;
    }
  }
}

.code-text {
  font-family: monospace;
  font-size: 12px;
  color: #1677ff;
  font-weight: 500;
}

.name-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 14px;
    color: #00b578;
  }
  
  span {
    font-weight: 500;
  }
}

.mobile-cell {
  display: flex;
  align-items: center;
  gap: 6px;
  
  i {
    font-size: 12px;
    color: #909399;
  }
  
  span {
    font-size: 12px;
    color: #606266;
  }
}

// 空状态
.empty-state {
  text-align: center;
  padding: 40px 20px;
  color: #c0c4cc;
  
  i {
    font-size: 64px;
  }
  
  p {
    margin-top: 16px;
    font-size: 14px;
  }
  
  .el-button {
    margin-top: 20px;
    border-radius: 20px;
  }
}

// 分页样式
.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  padding: 16px 0;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
  
  ::v-deep .el-pagination {
    .el-pager li.active {
      background: #1677ff;
      color: #fff;
    }
    
    .el-pagination__total {
      color: #8c8f98;
    }
  }
}

// 底部按钮样式
.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding-top: 16px;
  border-top: 1px solid #f0f0f0;
  margin-top: 8px;
  
  .el-button {
    border-radius: 20px;
    padding: 9px 24px;
  }
  
  .el-button--primary {
    background: #1677ff;
    border-color: #1677ff;
    
    &:hover {
      background: #4096ff;
      border-color: #4096ff;
    }
  }
  ::v-deep .el-input__inner,
  ::v-deep .el-select .el-input__inner {
    border-radius: 8px;
  }
}

// 响应式
@media (max-width: 768px) {
  .dialog-content {
    padding: 16px;
  }
  
  .search-section .search-input,
  .quick-add-section .add-input {
    max-width: 100%;
  }
  
  .quick-add-section .quick-add-row {
    flex-wrap: wrap;
  }
}
</style>